import { render, staticRenderFns } from "./OpinionsRating.vue?vue&type=template&id=54f03831&"
import script from "./OpinionsRating.vue?vue&type=script&lang=js&"
export * from "./OpinionsRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports